import { render, staticRenderFns } from "./SvButton.vue?vue&type=template&id=30f69f18&scoped=true&lang=pug&"
import script from "./SvButton.vue?vue&type=script&lang=js&"
export * from "./SvButton.vue?vue&type=script&lang=js&"
import style0 from "./SvButton.vue?vue&type=style&index=0&id=30f69f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f69f18",
  null
  
)

export default component.exports